// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Individual = t.struct({
    familiar: t.String,
    first: t.String,
    generation: t.String,
    last: t.String,
    middle: t.String,
    prefix: t.String,
    suffix: t.String
}, {
    name: 'Individual',
    strict: true
});

export const getDefaultState = () => new Individual({
    familiar: '',
    first: '',
    generation: '',
    last: '',
    middle: '',
    prefix: '',
    suffix: ''
});

export default Individual;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/individual.js